import { defineComponent as _defineComponent } from 'vue'
import { computed } from '@nuxtjs/composition-api';
import { BravadoButtonV3Size } from '~/components/common/BravadoButtonV3/types';
import type { ActiveBtnVariant } from '@/components/partials/sales-directory/types';
import BravadoButtonV3 from '~/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import RightArrow from '~/components/partials/sales-directory/assets/right-arrow.vue.svg';
import LeftArrow from '~/components/partials/sales-directory/assets/left-arrow.vue.svg';

type SalesDirectoryPaginationProps = {
  numberOfPages: number;
  selectedPageNumber: number;
  shownButtonsRange?: number;
  prefix: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'SalesDirectoryPagination',
  props: {
    numberOfPages: null,
    selectedPageNumber: null,
    shownButtonsRange: { default: 1 },
    prefix: null
  },
  setup(__props: any) {

const props = __props as { numberOfPages: number, selectedPageNumber: number, shownButtonsRange: number, prefix: string };



const isFirstPage = computed(() => props.selectedPageNumber === 1);
const isLastPage = computed(() => props.selectedPageNumber === props.numberOfPages);
const buttonsRange = computed(() => {
  const additionalRange = isLastPage.value || isFirstPage.value ? 1 : 0;
  return props.shownButtonsRange + additionalRange;
});
const visibleNumberOfPages = computed(() => {
  const pages = [props.selectedPageNumber];
  props.selectedPageNumber - 1 > 0 && pages.unshift(props.selectedPageNumber - 1);
  props.selectedPageNumber + 1 <= props.numberOfPages && pages.push(props.selectedPageNumber + 1);
  return pages;
});

function isNumberButtonInRange(buttonNumber: number) {
  return (
    buttonNumber <= props.selectedPageNumber + buttonsRange.value &&
    buttonNumber >= props.selectedPageNumber - buttonsRange.value
  );
}

function getActiveBtnVariant(buttonNumber: number): ActiveBtnVariant {
  return props.selectedPageNumber === buttonNumber ? 'primary' : 'secondary';
}

function pageLink({ number = props.selectedPageNumber, dir }: { number?: number; dir?: number }) {
  if (isFirstPage.value && dir === -1) return null;
  if (isLastPage.value && dir === 1) return null;
  const page = dir ? props.selectedPageNumber + dir : number;
  return { query: { prefix: props.prefix, page } };
}

return { __sfc: true,props, isFirstPage, isLastPage, buttonsRange, visibleNumberOfPages, isNumberButtonInRange, getActiveBtnVariant, pageLink, BravadoButtonV3Size, BravadoButtonV3, RightArrow, LeftArrow }
}

})